const SHOW_TOAST = 'SHOWTOAST';

export const displaySuccessToast = (message) => ({
  type: SHOW_TOAST,
  message,
  icon: 'success',
});

export const displayWarnToast = (message) => ({
  type: SHOW_TOAST,
  message,
  icon: 'warning',
});

export const displayErrorToast = (message) => ({
  type: SHOW_TOAST,
  message,
  icon: 'error',
});

export const displayInfoToast = (message) => ({
  type: SHOW_TOAST,
  message,
  icon: 'info',
});
